import React, { useMemo } from "react";
import { AnimatePresence } from "framer-motion";
import SerraCena from "./SerraCena";
import { getMessages } from "./messages";
import { useRotatingMessages } from "./useRotatingMessages";
import {
  HiddenLabel,
  LoaderShell,
  Message,
  MessageWrap,
} from "./styles";

/**
 * PageLoader — animação de marcenaria full-page com mensagens rotativas.
 *
 * Props:
 *  - scope?: string  — chave em `messages.js` (auth, home, clientes, ...).
 *  - message?: string | string[] — override total das mensagens.
 *  - intervalMs?: number — intervalo entre mensagens (default 2000).
 */
export default function PageLoader({ scope, message, intervalMs = 2000 }) {
  const messages = useMemo(() => {
    if (Array.isArray(message)) return message;
    if (typeof message === "string" && message.trim()) return [message];
    return getMessages(scope);
  }, [message, scope]);

  const current = useRotatingMessages(messages, intervalMs);

  return (
    <LoaderShell role="status" aria-busy="true" aria-live="polite">
      <SerraCena />
      <MessageWrap>
        <AnimatePresence mode="wait" initial={false}>
          <Message
            key={current}
            initial={{ opacity: 0, y: 6 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -6 }}
            transition={{ duration: 0.22, ease: [0.16, 1, 0.3, 1] }}
          >
            {current}
          </Message>
        </AnimatePresence>
      </MessageWrap>
      <HiddenLabel>Carregando dados, aguarde.</HiddenLabel>
    </LoaderShell>
  );
}
